export default {
  // list
  'crm_customer_account.column.customerId': '客户ID',
  'crm_customer_account.column.accountName': '账户名称',
  'crm_customer_account.column.bankName': '所属银行',
  'crm_customer_account.column.bankAccount': '银行账号',
  'crm_customer_account.column.bankBranch': '开户行',
  'crm_customer_account.column.accountHolder': '开户人',
  'crm_customer_account.column.primaryFlag': '是否首选',
  'crm_customer_account.column.enableFlag': '是否启用',
  'crm_customer_account.column.createBy': '创建人',
  'crm_customer_account.column.updateBy': '更新人',
  'crm_customer_account.column.createTime': '创建时间',
  'crm_customer_account.column.updateTime': '更新时间',
  'crm_customer_account.column.dataSource': '数据来源',
  'crm_customer_account.column.remark': '备注',
  'crm_customer_account.column.status': '状态',
  // edit
  'crm_customer_account.edit.title': '编辑客户资金账户',
  'crm_customer_account.add.title': '新增客户资金账户',
  'crm_customer_account.edit.success': '编辑成功',
  'crm_customer_account.add.success': '新增成功',
  'crm_customer_account.form.accountName.required': '账户名称不能为空',
  'crm_customer_account.form.bankName.required': '所属银行不能为空',
  'crm_customer_account.form.bankAccount.required': '银行账号不能为空',
  'crm_customer_account.form.bankBranch.required': '开户行不能为空',
  'crm_customer_account.form.primaryFlag.required': '是否首选不能为空',
  'crm_customer_account.form.enableFlag.required': '是否启用不能为空',
  'crm_customer_account.form.accountName': '账户名称',
  'crm_customer_account.form.accountName.placeholder': '请输入账户名称',
  'crm_customer_account.form.bankName': '所属银行',
  'crm_customer_account.form.bankName.placeholder': '请输入所属银行',
  'crm_customer_account.form.bankAccount': '银行账号',
  'crm_customer_account.form.bankAccount.placeholder': '请输入银行账号',
  'crm_customer_account.form.bankBranch': '开户行',
  'crm_customer_account.form.bankBranch.placeholder': '请输入开户行',
  'crm_customer_account.form.accountHolder': '开户人',
  'crm_customer_account.form.accountHolder.placeholder': '请输入开户人',
  'crm_customer_account.form.primaryFlag': '是否首选',
  'crm_customer_account.form.primaryFlag.placeholder': '请输入是否首选',
  'crm_customer_account.form.enableFlag': '是否启用',
  'crm_customer_account.form.enableFlag.placeholder': '请输入是否启用',
  'crm_customer_account.form.remark': '备注',
  'crm_customer_account.form.remark.placeholder': '请输入备注',
}
